import { Field, Form, FormikProps } from 'formik';
import { FormValues } from './types';
import styles from './ReportModal.module.css';
import { FormikDateRangePicker } from '../Forms/Components/DateRangePicker';
import { FormikRadioGroupInput } from '../Forms/Components/RadioGroup';
import CustomerField from './Customer';

type ReportFormProps = FormikProps<FormValues> & {
	id: string;
};

export default function InvoiceForm({ id }: ReportFormProps) {
	return (
		<Form
			className={styles['report-form']}
			id={id}
		>
			<div className={styles['flex-row']}>
				<Field
					name='reportDateRange'
					component={FormikDateRangePicker}
					label='Date Range'
					className={styles['date-range-input']}
				/>
			</div>
			<div className={styles['flex-row']}>
				<Field
					name='deliveryDateRange'
					component={FormikDateRangePicker}
					label='Delivery Date Range'
					className={styles['date-range-input']}
				/>
			</div>
			<div className={styles['flex-row']}>
				<CustomerField
					fieldName='customer'
					buttonClassName={styles['customer-dropdown']}
				/>
			</div>
			<div className={styles['flex-row']}>
				<Field
					component={FormikRadioGroupInput}
					name='accept'
					label='Report Format:'
					labelPlacement='top'
					defaultOptionSelected='HTML'
					radioItems={['HTML', 'Excel']}
				/>
			</div>
		</Form>
	);
}
